<template>
  <div>
    <header class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="tolast" v-if="!isWapp"></a>
      <h1 class="title">我的对账单</h1>
    </header>
    <div class="content">
      <div class="buttons-tab">
        <a href="#tab1" class="tab-link active button">个人对账单</a>
        <a href="#tab2" class="tab-link button">课题组对账单</a>
      </div>
      <div class="content-block" style="margin-top: 2rem">
        <div class="tabs">
          <div id="tab1" class="tab active">
            <div class="content-block">
                <OldAccountChecked></OldAccountChecked>
            </div>
          </div>
          <div id="tab2" class="tab">
            <div class="content-block">
              <div v-if="canWatch">
                <ChooseBillType :showComp="showComp" :researchGroupList="researchGroupList"></ChooseBillType>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseBillType from './ChooseBillType'
import OldAccountChecked from './OldAccountChecked'
import {mapGetters, mapState} from 'vuex'
import emkt from '../../../emkt.js'
export default {
  name: 'AllBill',
  components: {
    ChooseBillType,
    OldAccountChecked
  },
  mounted () {
    console.log('this.researchGroupSet', this.researchGroupSet)
    console.log('this.researchGroupAsLeaderList', this.researchGroupAsLeaderList)
  },
  data () {
    return {
      researchGroupList: [],
      isWapp: emkt.isWapp
    }
  },
  computed: {
    ...mapState([
      'sessionInfo', 'researchGroupSet'
    ]),
    ...mapGetters([
      'hasLogin', 'researchGroupAsLeaderList'
    ]),
    canWatch () {
      if (!this.researchGroupSet || this.researchGroupSet.length === 0) {
        this.researchGroupList = []
        return false
      }
      if (!this.hasLogin || !this.sessionInfo.customerInfo.customerNo) {
        this.researchGroupList = []
        return false
      }
      const customerNo = this.sessionInfo.customerInfo.customerNo
      // const customerNo = '00004380'
      for (let researchGroup of this.researchGroupSet) {
        if (customerNo === researchGroup.leaderNo || customerNo === researchGroup.accountCustomerNo) {
          this.researchGroupList.push(researchGroup)
        }
      }
      if (this.researchGroupList.length > 0) {
        return true
      }
      return false
    },
    showComp () {
      if (this.canWatch) {
        if (this.researchGroupList.length > 1) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods: {
    tolast () {
      this.$router.push({name: 'me'})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AllBill.vue?1adfaec4